import { combineReducers } from "redux";
import { withFetchingEntityListItems } from "../../../../Application/reducers/hoc/withFetchingItems";

import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";

import { packDetailsReducer } from "./packDetailsReducer";
import packEntityStateReducer from "./packEntityStateReducer";
import { packListingReducer } from "./packListingReducer";
import packTypesSlice from "../slices/packTypesSlice";
import packLicenseTypesSlice from "../slices/packLicenseTypesSlice";
import packsSearchSlice from "../slices/packsSearchSlice";
import packsOverviewFiltersSlice from "../slices/packsOverviewFiltersSlice";
import accountPacksFiltersSlice from "../slices/accountPacksFiltersSlice";
import packsOverviewGridSlice, { type OverviewState } from "../slices/packsOverviewSlice";
import availablePacksSearchSlice from "../slices/availablePacksSearchSlice";
import packVisibilityForAccountsSlice from "../slices/packVisibilityForAccountsSlice";
import packAccountTypesVisibilitySlice from "../slices/packAccountTypesVisibilitySlice";
import accountPacksSearchSlice from "../slices/accountPacksSearchSlice";
import requestedPacksLicensesSlice from "../slices/requestedPacksLicensesSlice";
import packContentTab from "./packContentTabReducer";
import packPurchasedViewSlice from "../slices/packPurchasedViewSlice";
import packUserLicensesSlice from "../slices/packUserLicensesSlice";
import packGroupLicensesSlice from "../slices/packGroupLicensesSlice";
import packIssueLicenseModalSlice from "../slices/packIssueLicenseModalSlice";
import packUsersAvailableForLicensingSlice from "../slices/packUsersAvailableForLicensingSlice";
import { accountFiltersReducer } from "../slices/accountFilterSlice";
import accountTypesAvailableForPackSlice from "../slices/accountTypesAvailableForPackSlice";
import packTrialPeriodsSlice from "../slices/packTrialPeriodsSlice";
import accountPackLicensesSlice from "../slices/accountPackLicensesSlice";
import packFiltersSlice from "../slices/packFiltersSlice";
import packGroupsAvailableForLicensingSlice from "../slices/packGroupsAvailableForLicensingSlice";
import userAvailablePacksGridSlice from "../slices/userAvailablePacksGridSlice";
import peopleIssueLicenseModalSlice from "../slices/peopleIssueLicenseModalSlice";
import groupAvailablePacksGridSlice from "../slices/groupAvailablePacksGridSlice";
import associatedPacksSlice from "../slices/associatedPacksSlice";
import packBillingTermsSlice from "../slices/packBillingTermsSlice";
import packSettingsReducer from "../slices/packSettingsSlice";
import paymentReducer from "features/Licensing/Packs/PaymentModal/state/paymentReducer";
import packPricingTypesSlice from "../slices/packPricingTypesSlice";

const namespace = ReducerNamespaceTypes.Licensing;
const entityPrefix = ReducerEntityPrefixTypes.Packs;

const packsReducer = combineReducers({
  overviewList: withFetchingEntityListItems<OverviewState>(namespace, entityPrefix),
  overviewGrid: packsOverviewGridSlice,
  packDetailsReducer,
  packSettingsReducer,
  packListingReducer,
  packEntityStateReducer,
  packFilters: packFiltersSlice,
  packsVisibilityForAccount: packVisibilityForAccountsSlice,
  accountTypesVisibility: packAccountTypesVisibilitySlice,
  availableAccountTypesForPack: accountTypesAvailableForPackSlice,
  packTypes: packTypesSlice,
  requestedPacksLicenses: requestedPacksLicensesSlice,
  packLicenseTypes: packLicenseTypesSlice,
  overviewSearch: packsSearchSlice,
  packsOverviewFilters: packsOverviewFiltersSlice,
  accountPacksFilters: accountPacksFiltersSlice,
  packsModalSearch: availablePacksSearchSlice,
  accountPacksSearch: accountPacksSearchSlice,
  packContentTab,
  purchasedPack: combineReducers({
    packPurchasedView: packPurchasedViewSlice,
    packUserLicenses: packUserLicensesSlice,
    packGroupLicenses: packGroupLicensesSlice,
    issueLicenseModal: combineReducers({
      modal: packIssueLicenseModalSlice,
      usersAvailableForLicensing: packUsersAvailableForLicensingSlice,
      groupsAvailableForLicensing: packGroupsAvailableForLicensingSlice,
    }),
  }),
  accountsFilters: accountFiltersReducer,
  packTrialPeriods: packTrialPeriodsSlice,
  packBillingTerms: packBillingTermsSlice,
  packPricingTypes: packPricingTypesSlice,
  peopleIssueLicenseModal: combineReducers({
    modal: peopleIssueLicenseModalSlice,
    userAvailablePacks: userAvailablePacksGridSlice,
    groupAvailablePacks: groupAvailablePacksGridSlice,
  }),
  shared: combineReducers({
    accountPacks: accountPackLicensesSlice,
  }),
  associatedPacks: associatedPacksSlice,
  payment: paymentReducer,
});

export type PacksState = ReturnType<typeof packsReducer>;

export { packsReducer };
